



export class ZalogujPrzezFbModel {
    email: string;
    facebookId: string;
}